export default __webpack_public_path__ + "static/media/hht1_ep12_minisitcom_01.910f4ea7.png";